/**
 * SolutionsBuilders — `/solutions/builders` route.
 * Body is the hand-built design from `solutions-builders.html`.
 * Navbar + Footer + App.js routing unchanged.
 */
import { Helmet } from "react-helmet-async";
import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { SolutionsBuildersHero } from "../components/SolutionsBuildersHero";

export default function SolutionsBuilders() {
  return (
    <main className="min-h-screen bg-aubergine" data-testid="solutions-builders-page">
      <Helmet>
        <title>For Builders : T-REX Network</title>
      </Helmet>
      <Navbar />
      <div aria-hidden="true" style={{ height: 64 }} />
      <SolutionsBuildersHero />
      <Footer />
    </main>
  );
}
